var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTirerLesRideaux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.566 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 846",
    d: "M63.726 58.32H60.7V5.078A5.084 5.084 0 0 0 55.624 0H10.263a5.084 5.084 0 0 0-5.078 5.078V58.32H1.84a1.84 1.84 0 0 0 0 3.68h61.886a1.84 1.84 0 0 0 0-3.68Zm-6.7-29.2v29.2H34.783V3.673h20.841a1.4 1.4 0 0 1 1.4 1.4v24.044Zm-25.668 3.074V58.32H9.119V5.078a1.4 1.4 0 0 1 1.4-1.4h20.839v28.516Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 847",
    d: "M10.476 52.526v-46.7H30.09V52.12a3.181 3.181 0 0 1-1.389.384c-1.821-.05-3.034-1.407-4-4.412-.013-.056-.027-.081-.04-.13a.172.172 0 0 1-.02-.074h-.013a.462.462 0 0 0-.4-.3.486.486 0 0 0-.4.3h-.007a.649.649 0 0 0-.067.235c-.978 3.036-2.225 4.4-4.106 4.4h-.007c-1.895 0-3.129-1.369-4.106-4.437-.013-.05-.027-.074-.047-.13-.007-.025-.02-.031-.02-.068h-.02a.461.461 0 0 0-.4-.3.486.486 0 0 0-.4.3.649.649 0 0 0-.067.235c-.983 3.043-2.224 4.403-4.105 4.403Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 848",
    d: "M36.056 52.526v-46.7H55.67V52.12a3.181 3.181 0 0 1-1.389.384c-1.821-.05-3.034-1.407-4-4.412-.013-.056-.027-.081-.04-.13a.171.171 0 0 1-.02-.074h-.007a.462.462 0 0 0-.4-.3.487.487 0 0 0-.4.3h-.007a.647.647 0 0 0-.067.235c-.978 3.036-2.225 4.4-4.106 4.4h-.007c-1.895 0-3.129-1.369-4.106-4.437-.013-.05-.027-.074-.047-.13-.007-.025-.02-.031-.02-.068h-.02a.461.461 0 0 0-.4-.3.486.486 0 0 0-.4.3.65.65 0 0 0-.068.235c-.988 3.043-2.229 4.403-4.11 4.403Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTirerLesRideaux);
export default __webpack_public_path__ + "static/media/tirer-les-rideaux.b5324c42dd2a501bd30a37e151ad8ae3.svg";
export { ForwardRef as ReactComponent };